import { omit } from "lodash";
import { nanoid } from "nanoid";
import { getCurrentAdScenario } from "@/hooks/useAdScenario";
import { useTranAdGestureUnlocked } from "@/hooks/useGoogleAd";
import Interstitial1 from "./Interstitial1";
const shouldRenderAd = (hostName: string): boolean => {
  // 暂时不加广告的域名列表
  const excludedDomains = [
    // "en-wg.comfortweather.com",
    "rs-wg.comfortweather.com",
    "hi-wg.comfortweather.com",
    "id-wg.comfortweather.com",
    "es-wg.comfortweather.com",
    "pt-br-wg.comfortweather.com",
    // "en-miwg.comfortweather.com",
    // "hi-miwg.comfortweather.com",
    // "id-miwg.comfortweather.com",
    "rs-miwg.comfortweather.com",
    "rs-mils.comfortweather.com",
    "localhost",
    "24hweather.com",
    // ...tranDomains,
  ];
  return !excludedDomains.includes(hostName);
};
export default function GoogleAd1(props: any) {
  // return <div>Hello World</div>;
  const { hostName } = useHostName();
  const { subdomain } = useSubdomain();
  const dataPosition = props.dataPosition;
  const isInterstitial = props.type === "interstitial";
  const { shouldGestureGateAds } = getCurrentAdScenario();
  const isTranAdGestureUnlocked = useTranAdGestureUnlocked(shouldGestureGateAds);

  const [refreshId, setRefreshId] = useState(() => (isInterstitial ? "" : nanoid(8)));
  useEffect(() => {
    if (isInterstitial) {
      return;
    }
    setRefreshId(nanoid(8));
  }, [isInterstitial]);

  // 针对不同域名的显示位置配置
  // wg域名允许的广告位置
  const displayPositons1 = [
    "position-21",
    "position-22",
    "position-08",
    "position-23",
    "position-20",
    "position-02",
    "position-24",
    "position-25",
    "position-26",
    "position-01",
  ];
  // miwg域名允许的广告位置（home-a1被禁用）
  const displayPositons2 = [
    "position-21",
    "position-22",
    // "position-08",
    "position-23",
    "position-20",
    "position-02",
    "position-24",
    "position-25",
    "position-26",
    "position-01",
  ];
  // wgDomains3域名允许的广告位置
  const displayPosition3 = ["position-21", "position-08", "position-11", "position-09", "position-10", "position-01"];
  // miwgDomain1域名允许的广告位置
  const displayPosition4 = [
    // "position-21",
    "position-08",
    "position-11",
    "position-09",
    "position-10",
    "position-01",
  ];

  let shouldRenderCurrentAd = !(shouldGestureGateAds && !isTranAdGestureUnlocked);

  if (subdomain) {
    const currentDomain = `${subdomain}.comfortweather.com`;
    // 如果当前域属于wg域且不属于wgDomains3域
    if ([...domainMap?.wg]?.includes?.(currentDomain) && ![...wgDomains3]?.includes?.(currentDomain)) {
      // 检查当前位置是否在允许的wg域位置列表中
      if (!displayPositons1.includes(dataPosition)) {
        shouldRenderCurrentAd = false;
      }
    }
    // 如果当前域属于miwg域且不属于miwgDomain1域
    if ([...domainMap?.miwg]?.includes?.(currentDomain) && ![...miwgDomain1].includes(currentDomain)) {
      // 检查当前位置是否在允许的miwg域位置列表中
      if (!displayPositons2.includes(dataPosition)) {
        shouldRenderCurrentAd = false;
      }
    }
  }
  // 检查wgDomains3域名是否允许在当前位置显示广告
  if ([...wgDomains3].includes(hostName) && !displayPosition3.includes(dataPosition)) {
    shouldRenderCurrentAd = false;
  }
  // 检查miwgDomain1域名是否允许在当前位置显示广告（包括home-a5）
  if ([...miwgDomain1].includes(hostName) && !displayPosition4.includes(dataPosition)) {
    shouldRenderCurrentAd = false;
  }
  // 检查props是否为空（排除dataPosition后）
  if (isEmptyType(omit(props, ["dataPosition"]))) {
    shouldRenderCurrentAd = false;
  }
  // 检查当前主机名是否应该渲染广告
  if (!shouldRenderAd(hostName)) {
    shouldRenderCurrentAd = false;
  }
  // 插屏广告不依赖 dataPosition 过滤，直接跳过位置检查
  // （插屏是全屏弹出式广告，由 GPT 全权管理渲染，不嵌入页面内容流）
  if (props.type === "interstitial") {
    shouldRenderCurrentAd = true;
  }

  // 对于特定类型的广告（ads、adx、anchor），检查是否有slot属性
  if (["ads", "adx", "anchor"].includes(props.type) && !props?.slot) {
    shouldRenderCurrentAd = false;
  }

  useAdBodyClass(props.type, dataPosition, shouldRenderCurrentAd);

  if (!shouldRenderCurrentAd) {
    return null;
  }

  // 分离type和其他参数
  const { type, ...args } = props;
  const AdCpt: any = {
    ads: () => <Ads1 {...args} />,
    adx: () => <Adx1 key={refreshId} {...args} />,
    dex: () => <Dex1 key={refreshId} {...{ ...props }} />,
    floorAd: () => <Dex1 key={refreshId} {...props} />,
    anchor: () => <Anchor1 key={refreshId} {...{ ...props }} />,
    // interstitial 只允许按控制器状态机挂载一次，不能复用通用 refresh key 机制，
    // 否则组件会在首屏自发 remount，导致额外的 GPT 请求。
    interstitial: () => <Interstitial1 {...{ ...props }} />,
  };
  return AdCpt?.[type]?.();
}
